import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { AlertsTypeRes } from "../patients/index.type";

interface IAlerts {
  key: string;
  value: string;
}

const useGetAlerts = () => {
  const [alerts, setAlerts] = React.useState<IAlerts[]>([]);

  const { loading: loadingAlerts, makeApiCall } = useApi({
    url: `/rtm/billing-cycle/alert-list`,
    method: "GET",
  });

  const getAlerts = async () => {
    const { response, error } = await makeApiCall<undefined, AlertsTypeRes>();

    if (response?.status && response.data) {
      setAlerts(response.data);
    }
    if (error) {
      toast.error(error.msg);
      setAlerts([]);
    }
  };

  return {
    alerts,
    getAlerts,
    loadingAlerts,
  };
};

export default useGetAlerts;
